// extracted by mini-css-extract-plugin
export default {"modalTabs":"NewPopup_modalTabs__cflaV","analyticsModal":"NewPopup_analyticsModal__9F0KK","tabContent":"NewPopup_tabContent__uIF5u"};